import { Button } from '@/atoms/Button'

export type AgencyToolbarProps = {
  agencyCount: number
  onCreateAgency?: () => void
}

export function AgencyToolbar({ agencyCount, onCreateAgency }: AgencyToolbarProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 border-b-2 border-ink pb-5">
      <div>
        <p className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-muted">
          Platform
        </p>
        <h1 className="mt-2 font-display text-3xl font-medium tracking-[-0.02em] text-ink">
          Agencies
        </h1>
        <p className="mt-1 text-sm text-muted">
          {agencyCount} {agencyCount === 1 ? 'agency' : 'agencies'} on the platform
        </p>
      </div>

      <Button type="button" disabled={!onCreateAgency} onClick={onCreateAgency}>
        Create agency
      </Button>
    </div>
  )
}
